export const isObjectCompletelyFilled = (data = {}, keysToIgnore = []) => {
  if (!data || typeof data !== "object") return false;

  return Object.keys(data).every((key) => {
    if (keysToIgnore.includes(key)) return true;

    const val = data[key];

    // Check for null or undefined
    if (val === null || val === undefined) return false;

    // Check for empty strings
    if (typeof val === "string" && val.trim() === "") return false;

    // Check for empty arrays
    if (Array.isArray(val) && val.length === 0) return false;

    return true;
  });
};

export const validateImageFile = (file, maxMb = 5) => {
  if (!file) {
    return { isValid: false, error: "No image file selected." };
  }

  // Exact allowed MIME types array
  const allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/webp",
    
    "image/heic",
    "image/heif",
  ];

  const fileType = file.type?.toLowerCase();
  const fileName = file.name?.toLowerCase() || "";

  // Check against allowed MIME types array or file extensions for HEIC/HEIF
  const isTypeAllowed =
    allowedTypes.includes(fileType) ||
    fileName.endsWith(".heic") ||
    fileName.endsWith(".heif");

  if (!isTypeAllowed) {
    return {
      isValid: false,
      error: "Only JPEG, PNG, WebP, HEIC, and HEIF image formats are allowed.",
    };
  }

  // Dynamic MB Size Validation
  const maxBytes = maxMb * 1024 * 1024;
  if (file.size > maxBytes) {
    return {
      isValid: false,
      error: `File size exceeds the maximum limit of ${maxMb} MB.`,
    };
  }

  return { isValid: true, error: null };
};